import { Pipe, PipeTransform } from "@angular/core";
import { ReportDto } from "@api";

@Pipe({ name: "parseReportEmoji" })
export class ParseReportEmojiPipe implements PipeTransform {
  public transform(report: ReportDto): string {
    if (report?.isBottleneck) {
      return "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/285/weary-face_1f629.png";
    }

    if (report?.status === ReportDto.StatusEnum.Warning) {
      return "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/285/flushed-face_1f633.png";
    }

    if (report?.status === ReportDto.StatusEnum.Success) {
      return "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/apple/285/grinning-face_1f600.png";
    }
  }
}
